import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import UploadModal from '../../components/UploadModal';
import UploadAttachmentForm from '../BookingPaymentPictures/Form';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { flashSuccessMessage } from '../../actions/flash';
import { validateForm } from '../../utils/validations';

class BookingChangeUnit extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
    }),
    open: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    headerNode: PropTypes.node,
    data: PropTypes.shape({
      projectID: PropTypes.string,
      project: PropTypes.shape({
        name: PropTypes.string,
      }),
      projectUnitID: PropTypes.string,
      projectUnit: PropTypes.shape({
        reference: PropTypes.string,
      }),
    }).isRequired,
    changeProjectID: PropTypes.string,
    changeSelectedProject: PropTypes.shape({
      value: PropTypes.string,
      text: PropTypes.string,
    }),
    changeSelectedUnit: PropTypes.shape({
      value: PropTypes.string,
      text: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  constructor(props) {
    super(props);
    this.state = {
      attachmentsUploaded: {},
      attachmentsUploadedCount: 0,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.open === true && nextProps.open !== this.props.open) {
      this.setState({
        attachmentsUploaded: {},
        attachmentsUploadedCount: 0,
      });
    }
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnConfirm = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { data } = this.props;
    const { attachmentsUploaded, attachmentsUploadedCount } = this.state;
    if (data.cuAttachmentsRequired) {
      const validations = [{
        isValid: attachmentsUploadedCount > 0,
        key: '',
        message: 'Attachment is required',
      }];

      if (validateForm(store, validations)) return;
    }
    if (this.props.onConfirm) {
      this.props.onConfirm({
        attachmentsUploaded,
        attachmentsUploadedCount,
      });
    }
  }
  async uploadAttachments(e, body) {
    e.preventDefault();
    const { store } = this.context;
    const { t } = this.props;
    this.setState({
      attachmentsUploaded: body,
      attachmentsUploadedCount: body.get('total_attached'),
    });
    this.uploadModal.close();
    store.dispatch(flashSuccessMessage({
      header: t('Attached', { ns: TRANSLATION_FILES.translation }),
      message: t('Attachment(s) attached', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleCheckBoxChange = (event, d) => {
    const { data } = this.props;
    data[d.name] = !data[d.name];
    this.setState({ data }, () => {
      this.handleCheckChanges();
    });
  }
  handleUploadModalClose = () => this.uploadModal.close();
  hasAccess(check = false, admin = true, dhq = true, dbl = true, internal = false) {
    const auth = this.props.auth;
    if (dbl && this.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && this.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && this.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  render() {
    const { t, data, changeProjectID, changeSelectedProject, changeSelectedUnit } = this.props;
    const { attachmentsUploadedCount } = this.state;
    return (
      <Modal
        className="booking-change-unit"
        open={this.props.open === true}
        onClose={this.handleOnClose}
        size="small"
      >
        <Header icon="file text outline" content={this.props.headerNode || `${t('Perform unit change')}?`} />
        <Modal.Content>
          <Modal.Description style={{ paddingBottom: '1em' }}>
            <div>
              <Grid stackable>
                <Grid.Row>
                  <Grid.Column>
                    <p>{t('Please confirm following changes')}</p>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="booking-change-unit-info">
                  <Grid.Column>
                    <Grid style={{ marginLeft: 0, marginRight: 0 }} stackable>
                      <Grid.Row>
                        <b>{t('Project')}</b>
                      </Grid.Row>
                      <Grid.Row columns={2}>
                        <Grid.Column>
                          {data && data.project ? data.project.name : '-'}
                        </Grid.Column>
                        {
                          data.projectID !== changeProjectID && (
                            <Grid.Column>
                              <Icon name="caret right" />
                              {changeSelectedProject ? changeSelectedProject.text : '-'}
                            </Grid.Column>
                          )
                        }
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="booking-change-unit-info">
                  <Grid.Column>
                    <Grid style={{ marginLeft: 0, marginRight: 0 }} stackable>
                      <Grid.Row>
                        <b>{t('Unit')}</b>
                      </Grid.Row>
                      <Grid.Row columns={2}>
                        <Grid.Column>
                          {data && data.projectUnit ? data.projectUnit.reference : '-'}
                        </Grid.Column>
                        <Grid.Column>
                          <Icon name="caret right" />
                          {changeSelectedUnit ? changeSelectedUnit.text : '-'}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="booking-change-unit-info">
                  <Grid.Column>
                    <Grid style={{ marginLeft: 0, marginRight: 0 }} stackable>
                      <Grid.Row>
                        <b>{t('Criteria')}</b>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column>
                          <Form.Checkbox
                            label={t("Follow previous booking's Created Date")}
                            name="cuFollowPrevBookingDateIsEnabled"
                            checked={data.cuFollowPrevBookingDateIsEnabled}
                            onChange={this.handleCheckBoxChange}
                            disabled={data.project.cuDisabledEditingOfFollowPrevBookingDate && !this.hasAccess(false, true, true, true, true)}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="booking-change-unit-info">
                  <Grid.Column>
                    <Grid.Row>
                      <b>{t('Attachments')}{data.cuAttachmentsRequired && '*'}</b>
                    </Grid.Row>
                    <Grid.Row style={{ paddingTop: '0.8em' }}>
                      <UploadModal
                        trigger={(
                          <span>
                            <Button basic>
                              <Icon name="attach" />
                              {t('Select File')}
                            </Button>
                            {
                              attachmentsUploadedCount > 0 ? (
                                <Label color="blue" circular size="tiny">
                                  {attachmentsUploadedCount}
                                </Label>
                              ) : null
                            }
                          </span>
                        )}
                        ref={(ref) => { this.uploadModal = ref; }}
                        header="attachments"
                        loading={this.state.loading}
                        onConfirm={(e, file) => {
                          this.uploadAttachments(e, file);
                        }}
                        onClose={this.handleUploadModalClose}
                        primary={false}
                        content={opt => (
                          <UploadAttachmentForm
                            fileType="attachment"
                            btnText="Files"
                            loading={this.state.loading}
                            onSubmit={opt.onConfirm}
                          />
                        )}
                      />
                    </Grid.Row>
                    Upload jpeg, jpg, png, pdf no larger than 10MB.
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={this.handleOnClose} icon="cancel" content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
          <Button
            positive
            onClick={e => this.handleOnConfirm(e, data)}
            icon="checkmark"
            content={t('Confirm', { ns: TRANSLATION_FILES.translation })}
            disabled={data.cuAttachmentsRequired && attachmentsUploadedCount < 1}
            data-bot-target="confirm"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation([
  ...namespaces,
])(connect(BookingChangeUnit.mapStateToProps)(BookingChangeUnit));



// WEBPACK FOOTER //
// ./src/containers/modals/BookingChangeUnit.jsx